import React from 'react';
import { connect } from 'react-redux';
import {Link} from 'react-router-dom';
import {check, isAbmPseudoLoggedIn, isRdrPseudoLoggedIn} from '../../../utils/tokenUtils';
import Rewards from './navbar-items/rewards';
import AdminLinks from './navbar-items/admin-links';
import LatestNews from './navbar-items/latest-news';
import Information from './navbar-items/information';
import MyStore from './navbar-items/my-store';
import {checkPermission} from '../../common/guards/can';

function buildRewardLinks(props) {
  const links = [];

  if (checkPermission('view', 'objective_info,objective_performance', 'AND')) {
    if (props.atLeastOneActiveSellItIncentive) {
      links.push(<Link to={'/store-performances#sellit'} onClick={() => props.handleMenu()}>Sell IT objectives</Link>);
    }
    if (props.hasStockItOutlet) {
      links.push(<Link to={'/store-performances#stockit'} onClick={() => props.handleMenu()}>Stock IT objectives</Link>);
    }
    if (props.hasPriceItOutlet) {
      links.push(<Link to={'/store-performances#priceit'} onClick={() => props.handleMenu()}>Price IT objectives</Link>);
    }
    links.push(<Link to={'/store-performances'} onClick={() => props.handleMenu()}>Store performance</Link>);
  }
  if (props.userGroup !== 'staff' && props.optedInToPpc) {
    // eslint-disable-next-line max-len
    links.push(<Link to={{ pathname: props.ppcManagementUrl }} target='_blank' onClick={() => props.handleMenu()}>Ignite Mastercard Management</Link>);
  }
  if (checkPermission('view', 'web_app_points')) {
    links.push(<Link to={'/points-statement#owners'} onClick={() => props.handleMenu()}>Points statement</Link>);
  }
  if (checkPermission('handle', 'sell_it_uploader') && props.hasSellItOutlet && !isRdrPseudoLoggedIn() && !isAbmPseudoLoggedIn()) {
    links.push(<Link to={'/submissions#submit_epos_data'} onClick={() => props.handleMenu()}>Upload EPOS/Invoice</Link>);
  }
  if (checkPermission('view', 'web_app_level') && props.hasSellItOutlet) {
    links.push(<Link to={'/about-ignite'} onClick={() => props.handleMenu()}>Programme levels</Link>);
  }
  return links;
}

const NavbarMainMenu = (props) => {
  const rewardLinks = buildRewardLinks(props);
  return (
    <div className="nav-menu-links-container">
      {check() && props.hasRewardOutlet && !!rewardLinks.length && <Rewards handleMenu={props.handleMenu} links={rewardLinks} />}
      <AdminLinks handleMenu={props.handleMenu} />
      <LatestNews handleMenu={props.handleMenu} />
      <div className="nav-menu-column-container">
        <Information handleMenu={props.handleMenu} />
        {check() && <MyStore handleMenu={props.handleMenu} />}
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  hasRewardOutlet: state.viewConfig.profile.attributes['has-reward-outlet'],
  optedInToPpc: state.viewConfig.profile.attributes['opted-in-to-ppc'],
  hasSellItOutlet: state.viewConfig.profile.attributes['has-sell-it-outlet'],
  atLeastOneActiveSellItIncentive: state.viewConfig.profile.attributes['at-least-one-active-sell-it-incentive'],
  hasStockItOutlet: state.viewConfig.profile.attributes['has-stock-it-outlet'],
  hasPriceItOutlet: state.viewConfig.profile.attributes['has-price-it-outlet'],
  userGroup: state.viewConfig.profile.attributes['user-group'],
  ppcManagementUrl: state.ppc.ppcManagementUrl
});

export default connect(mapStateToProps)(NavbarMainMenu);



// WEBPACK FOOTER //
// ./src/components/layout/user-navigation/navbar-main-menu.jsx